import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Toolbar, ListItemButton, AppBar } from '@mui/material';
import {ReactComponent as OliIcon} from '../static/icons/Algo Olio.svg';
import {ReactComponent as LoginIcon} from '../static/icons/Log Out.svg'; // You may want to replace this with a proper login icon

const TopNavbar = () => {
  const navigate = useNavigate();
  
  const handleLoginClick = () => {
    navigate('/login');
  };

  return (
    <AppBar
      position="static"
      sx={{
        width: '100%',
        height: '9.5%',
        background: 'linear-gradient(0deg, rgba(0, 0, 0, 0.25) 0%, rgba(0, 0, 0, 0.25) 100%), linear-gradient(326deg, #A29EDA -46.9%, #916CB4 -29.33%, #8E3A88 27.57%, #6B3A8F 73.58%, #5D2A79 115.7%)',
        boxShadow: 'none',
        zIndex:5
      }}
    >
      <Toolbar sx={{ 
        display: 'flex',
        justifyContent: 'space-between',
        padding: '0 30px',
        height: '100%'
      }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <OliIcon width='60' height='60' style={{ marginRight: '30px' }}/>
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default TopNavbar;